import script from "./documentMixin.vue?vue&type=script&lang=js"
export * from "./documentMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__